import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { apiRoot } from '../../../services/api';
import AttendancesChart from './components/AttendancesChart';
import { useQueryParams } from '../../../hooks/useQueryParams';
import '../../../styles/fontawesome/css/all.min.css';
import './styles.css';

const initialParams = {
    begin_date: (new Date(
        (new Date()).setMonth(
            (new Date()).getMonth() - 12
        )
    )).toISOString(
        'YYYY-mm-dd'
    ).substring(0, 7),
    end_date: (new Date()).toISOString(
        'YYYY-mm-dd'
    ).substring(0, 7)
};

export default function AttendancesAnalysisPanel() {
    const history = useHistory();
    const queryParams = useQueryParams();
    const [params, setParams] = useState(
        Object.keys(queryParams).length > 0 ?
            queryParams : initialParams
    );
    const [data, setData] = useState([]);

    useEffect(() => {
        async function getData() {
            try {
                const res = await apiRoot.get(
                    'get-analysis-data',
                    { params: Object.keys(queryParams).length > 0 ? queryParams : params }
                );

                setData(res.data);
            } catch (error) {
                console.log(error);
            }
        }

        getData();
    }, [
        queryParams.begin_date,
        queryParams.end_date
    ]);

    function paramsToQuery() {
        let queryParamsString = '';

        Object.keys(params).map((key, index) => {
            queryParamsString += index > 0 ? '&' : '';
            queryParamsString += `${key}=${params[key]}`
        });

        return queryParamsString;
    }

    async function handleSubmit(event) {
        event.preventDefault();

        let queryParamsString = paramsToQuery();

        history.push(`/dados-atendimentos?${queryParamsString}`);
    }

    function handleClear() {
        setParams(initialParams);

        history.push('/dados-atendimentos');
    }

    return (
        <div className="AttendancesAnalysisPanel">
            <AttendancesChart
                params={params}
                setParams={setParams}
                handleSubmit={handleSubmit}
                handleClear={handleClear}
                counts={data}
            />
        </div>
    );
}

const analysisPanel = document.getElementById(
    'attendances-analysis-panel'
);

if (analysisPanel) {
    ReactDOM.render(
        <Router><AttendancesAnalysisPanel/></Router>,
        analysisPanel
    );
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Site/AttendancesAnalysisPanel/attendanceAnalysisPanel.js